import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components';
import { dashboardRoutePaths } from '@/routes/route-config';

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="/logo.svg"
            alt={t('screens.notFoundPage.dentacares')}
            className="h-16 w-auto opacity-90"
          />
        </div>

        {/* 404 number */}
        <p className="text-7xl font-bold tracking-tight text-primary mb-2 leading-none">
          404
        </p>

        {/* Heading */}
        <h1 className="text-xl font-semibold text-secondary mb-2">
          {t('notFound.title')}
        </h1>

        {/* Subtext */}
        <p className="text-sm text-neutral-500 mb-8 leading-relaxed">
          {t('notFound.body')}
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="secondary"
            onPress={() => navigate(-1)}
            className="flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('notFound.back')}
          </Button>
          <Button
            onPress={() => navigate(dashboardRoutePaths.home)}
            className="flex items-center justify-center gap-2 bg-primary hover:bg-primary-700 text-white border-0"
          >
            <Home className="w-4 h-4" />
            {t('notFound.home')}
          </Button>
        </div>
      </div>
    </div>
  );
}
